import { apiRequest } from '@common/api/utils';

function getEligibleData() {
  const URL = '/referrals/mentors/';
  return apiRequest(
    'GET',
    URL,
  );
}

export default {
  getEligibleData,
};
